import { render } from "./reporteavancegeneralec.vue?vue&type=template&id=a9c84276"
import script from "./reporteavancegeneralec.vue?vue&type=script&lang=js"
export * from "./reporteavancegeneralec.vue?vue&type=script&lang=js"

import "./reporteavancegeneralec.vue?vue&type=style&index=0&id=a9c84276&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__